(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["central-tools-product-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
      function showFirstTabOnly(container) {
        var idPrefix = container.dataset.tabInstance;
        if (!idPrefix) return;

        var buttons = container.querySelectorAll('.tabbed-content__tab-btn');
        var panels = container.querySelectorAll('.tabbed-content__panel');
        if (!buttons.length || !panels.length) return;

        buttons.forEach(function (btn, i) {
          var isFirst = i === 0;
          btn.classList.toggle('is-active', isFirst);
          btn.setAttribute('aria-selected', isFirst ? 'true' : 'false');
        });

        panels.forEach(function (panel, i) {
          var isFirst = i === 0;
          panel.classList.toggle('is-active', isFirst);
          if (isFirst) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', 'true');
          }
        });
      }

      function initTabbedContent(container) {
        if (container.dataset.tabbedInit === 'true') return;
        var idPrefix = container.dataset.tabInstance;
        if (!idPrefix) return;

        container.dataset.tabbedInit = 'true';

        var buttons = container.querySelectorAll('.tabbed-content__tab-btn');
        var panels = container.querySelectorAll('.tabbed-content__panel');

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var index = btn.dataset.tabIndex;

            buttons.forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-selected', 'false');
            });

            panels.forEach(function (p) {
              p.classList.remove('is-active');
              p.setAttribute('hidden', 'true');
            });

            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');

            var targetPanel = container.querySelector(
              '[id="tab-panel-' + idPrefix + '-' + index + '"]'
            );
            if (targetPanel) {
              targetPanel.classList.add('is-active');
              targetPanel.removeAttribute('hidden');
            }
          });
        });

        showFirstTabOnly(container);
      }

      document.querySelectorAll('[data-tabbed-content]').forEach(initTabbedContent);

      if (!window.__centralToolsTabbedContentBound) {
        window.__centralToolsTabbedContentBound = true;
        document.addEventListener('shopify:section:load', function (event) {
          event.target.querySelectorAll('[data-tabbed-content]').forEach(initTabbedContent);
        });
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabbed-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function initTabbedContent(container) {
      if (container.dataset.tabbedInit === 'true') return;
      var idPrefix = container.dataset.tabInstance;
      if (!idPrefix) return;

      container.dataset.tabbedInit = 'true';

      var buttons = container.querySelectorAll('.tabbed-content__tab-btn');
      var panels = container.querySelectorAll('.tabbed-content__panel');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = btn.dataset.tabIndex;

          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', 'true');
          });

          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          var targetPanel = container.querySelector(
            '[id="tab-panel-' + idPrefix + '-' + index + '"]'
          );
          if (targetPanel) {
            targetPanel.classList.add('is-active');
            targetPanel.removeAttribute('hidden');
          }
        });
      });
    }

    document.querySelectorAll('[data-tabbed-content]').forEach(initTabbedContent);

    if (!window.__tabbedContentSectionLoadBound) {
      window.__tabbedContentSectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll('[data-tabbed-content]').forEach(initTabbedContent);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
